@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.titleCell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  position: relative;
  gap: 8px;
  min-width: 0;
  padding-left: 26px;

  @include for-phone-only {
    flex-direction: column;
    flex: 1 1 auto;
    gap: 10px;
    align-items: flex-start;
    padding-left: 0;
  }
}

.iconContainer {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 5px;

  overflow: hidden;
  color: var(--dark-40);
  text-overflow: ellipsis;
  font-family: Sohne;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: 0.48px;
}

.iconWrapper,
.channelIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: $gray-10;
  color: var(--dark-80);
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
}

.channelIcon {
  background-color: transparent;
  width: auto;
  height: auto;

  svg {
    width: 20px;
    height: 20px;
  }
}

.emojiIcon {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.titleContentContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.contextText {
  overflow: hidden;
  color: var(--dark-40);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.14px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-top: -2px;
}

.titleContent {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  position: relative;

  @include for-phone-only {
    flex: 1 1 auto;
    gap: 10px;
  }
}

.titleContentRenaming {
  flex: 1 1 auto;
  width: 100%;
}

.titleButton {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: auto;
  max-width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.titleContentWrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;

  @include for-phone-only {
    gap: 10px;
  }
}

.titleText {
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;

  :global([class*='lineClampForceSingleLine']) {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.titleButton .favoriteToggle {
  flex-shrink: 0;
}

.favoriteButton {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.favoriteToggle {
  width: 28px;
  height: 28px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;

  svg {
    width: 18px;
    height: 18px;
  }

  @include for-phone-only {
    display: none;
  }
}

.favoriteToggle.favoriteButtonActive {
  opacity: 1;
  pointer-events: auto;

  svg {
    fill: $gold-50;
  }
}

.titleContentContainer:hover .favoriteToggle,
.titleContentWrapper:hover .favoriteToggle,
.titleButton:hover .favoriteToggle {
  opacity: 1;
  pointer-events: auto;
}

// Also show when parent row is hovered (using :global for cross-module selector)
:global(.row:hover) .favoriteToggle {
  opacity: 1;
  pointer-events: auto;
}

.renameForm {
  width: 100%;
}

.renameInput {
  width: 100%;
  border: 1px solid var(--dark-10);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 16px;
  line-height: 1.3;
  font-family: inherit;
  color: var(--dark-80);
  background: var(--neutral-0);

  &:focus {
    outline: none;
    border-color: var(--action-50);
    box-shadow: 0 0 0 3px rgba(40, 127, 189, 0.2);
  }
}
